export interface EmojiPlayerOptions {
    container: HTMLElement;
    lottieData?: any;
    duration?: number | "auto";
    renderer?: "svg" | "canvas";
}

export class EmojiPlayer {
    private _element: HTMLElement;
    private _playing: boolean = false;
    private _player: LottiePlayer;
    private _duration: number | "auto" = "auto";
    private _lottieData: any = null;

    constructor(options: EmojiPlayerOptions) {
        options = e5.object.merge({
            duration: "auto",
            renderer: "svg"
        }, options);
        this._duration = options.duration;

        this._element = document.createElement("div");
        this._element.className = "emoji-player";
        this._element.innerHTML = `
        <lottie-player class="emoji-player__lottie" renderer="${options.renderer}"></lottie-player>
        `;

        this._player = this._element.querySelector(".emoji-player__lottie") as LottiePlayer;
        // this._player.renderer = options.renderer;
        this._player.loop = true;
        this._player.addEventListener("complete", (e) => {
            if (!this._playing) {
                this._player.pause();
                this._player.seek(0);
            }
        });

        if (options.lottieData) {
            this._lottieData = options.lottieData;
            this.updateSpeed();
            this._player.src = options.lottieData;
        }

        options.container.appendChild(this._element);
    }

    public load(lottieData: Object) {
        this._lottieData = lottieData;
        this.updateSpeed();
        this._player.load(lottieData);
    }

    public get duration(): number | "auto" {
        return this._duration;
    }

    public set duration(value: number | "auto") {
        this._duration = value;
        this.updateSpeed();
    }

    private updateSpeed() {
        // this._player.setSpeed(1);
        // return;

        let speed = 1;
        if (!this._lottieData || this._duration === "auto") {
            speed = 1;
        } else {
            let frameRate = this._lottieData.fr;
            // let firstFrame = this._lottieData.ip;
            let lastFrame = this._lottieData.op;
            let duration = lastFrame / frameRate;
            speed = duration / (this._duration + 0.1);
        }

        if ((this._player as any)._lottie) {
            this._player.setSpeed(speed);
        } else {
            this._player.speed = speed;
        }
    }

    public get grayscale(): boolean {
        return this._element.classList.contains("emoji-player--grayscale");
    }

    public set grayscale(value: boolean) {
        this._element.classList.toggle("emoji-player--grayscale", value);
    }

    public seek(ratio: number): void {
        if (!this._lottieData) {
            return;
        }

        ratio = e5.Calc.clamp(ratio, 0, 1);
        let frame = Math.floor(this._lottieData.op * ratio);
        frame = e5.Calc.clamp(frame, 0, this._lottieData.op - 1);
        this._player.seek(frame);
    }

    public get playing(): boolean {
        return this._playing;
    }

    public set playing(value: boolean) {
        if (this._playing == value) {
            return;
        }
        this._playing = value;

        if (value) {
            this._player.setLooping(true);
            this.updateSpeed();
            this._player.play();
        } else {
            this._player.setLooping(false);
            this._player.setSpeed(3);
        }
    }

    public dispose() {
        this.playing = false;
        this._element.remove();
        this._player = null;
        this._element = null;
    }
}